import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box } from "@mui/material";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import ReviewsList from "../../features/manageReviews/reviewsList";

const ManageReviews = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Reviews</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage Reviews
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </Box>
          </div>
        </div>
        <ReviewsList />
      </div>
    </MainContainer>
  );
};

export default ManageReviews;
